module.exports = __webpack_public_path__ + "static/media/filter-black.b588fd67.svg";